import Base from './BaseWithFormatting.js';
import Broker from '../mixins/Broker.js';
import Trustpilot from '../mixins/Trustpilot.js';
import Compliance from '../mixins/Compliance.js';
import Requirements from '../mixins/Requirements.js';
import AviFee from '../mixins/AviFee.js';
import SetupFee from '../mixins/SetupFee.js';
import AcceptsPaymentRemarks from '../mixins/AcceptsPaymentRemarks.js';

export default class Mortgage extends AcceptsPaymentRemarks(SetupFee(AviFee(Requirements(Compliance(Trustpilot(Broker(Base))))))) {

    get title() {
        return this._data.title;
    }

    get maxLTVRatio() {
        return this._data.max_ltv_ratio;
    }

    get maxLTVRatioString() {
        return this.formatPercentage(this.maxLTVRatio);
    }

    get downPaymentRatio() {
        return 100 - this.maxLTVRatio;
    }

    get downPaymentString() {
        return this.formatPercentage(this.downPaymentRatio);
    }

    get acceptsPartTimeJob() {
        return this._data.accepts_part_time_job;
    }

    get listInterest3m() {
        return this._data.list_interest_3m;
    }

    get listInterest1y() {
        return this._data.list_interest_1y;
    }

    get listInterest2y() {
        return this._data.list_interest_2y;
    }

    get listInterest3y() {
        return this._data.list_interest_3y;
    }

    get listInterest5y() {
        return this._data.list_interest_5y;
    }

    get listInterest7y() {
        return this._data.list_interest_7y;
    }

    get listInterest10y() {
        return this._data.list_interest_10y;
    }

    get listInterestStrings() {
        return {
            '3m' : this.formatPercentage(this.listInterest3m, 2),
            '1y' : this.formatPercentage(this.listInterest1y, 2),
            '2y' : this.formatPercentage(this.listInterest2y, 2),
            '3y' : this.formatPercentage(this.listInterest3y, 2),
            '5y' : this.formatPercentage(this.listInterest5y, 2),
            '7y' : this.formatPercentage(this.listInterest7y, 2),
            '10y' : this.formatPercentage(this.listInterest10y, 2), 
        }
    }

    get averageInterest3m() {
        return this._data.average_interest_3m;
    }

    get averageInterest1y() {
        return this._data.average_interest_1y;
    }

    get averageInterest2y() {
        return this._data.average_interest_2y;
    }

    get averageInterest3y() {
        return this._data.average_interest_3y;
    }

    get averageInterest5y() {
        return this._data.average_interest_5y;
    }

    get averageInterest7y() {
        return this._data.average_interest_7y;
    }

    get averageInterest10y() {
        return this._data.average_interest_10y;
    }

    get averageInterestStrings() {
        return {
            '3m' : this.formatPercentage(this.averageInterest3m, 2),
            '1y' : this.formatPercentage(this.averageInterest1y, 2),
            '2y' : this.formatPercentage(this.averageInterest2y, 2),
            '3y' : this.formatPercentage(this.averageInterest3y, 2),
            '5y' : this.formatPercentage(this.averageInterest5y, 2),
            '7y' : this.formatPercentage(this.averageInterest7y, 2),
            '10y' : this.formatPercentage(this.averageInterest10y, 2), 
        }
    }
}